import { render, staticRenderFns } from "./ToolboxTalkAttendee.vue?vue&type=template&id=22aad7e0&"
import script from "./ToolboxTalkAttendee.vue?vue&type=script&lang=js&"
export * from "./ToolboxTalkAttendee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports